import { React, useState, useEffect } from 'react'
import axios from 'axios'
import ModalInProcess from './ModalInProcess'
import { FaEdit } from "react-icons/fa";
function NewRequests({ consultations = [], consultants = [], fetchConsultations }) {
  //   const [consultations, setConsultations] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedConsultation, setSelectedConsultation] = useState(null)
  //   const token = localStorage.getItem("token")
  // console.log(consultants);

  const openModal = (consultation) => {
    setSelectedConsultation(consultation)
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setSelectedConsultation(null)
  }
  // console.log(consultants);



  return (
    <>
      <div className="flex flex-wrap space-x-6">
        <div className="flex flex-col space-y-6 w-full">
          <div className="px-10 py-6 bg-white rounded">
            <table className="w-full table-auto border-t border-b border-gray-300">
              <thead>
                <tr className="border-b border-gray-300">
                  <th className="px-4 py-2 text-center text-gray-400">Consultation ID</th>
                  <th className="px-4 py-2 text-center text-gray-400">Name</th>
                  <th className="px-4 py-2 text-center text-gray-400">Email</th>
                  <th className="px-4 py-2 text-center text-gray-400">Date</th>
                  <th className="px-4 py-2 text-center text-gray-400">Time</th>
                  <th className="px-4 py-2 text-center text-gray-400">Link</th>
                  <th className="px-4 py-2 text-center text-gray-400">Action</th>

                </tr>
              </thead>
              <tbody>
                {consultations.length > 0 ? consultations.map((consultation) => (
                  <tr
                    key={consultation.consultationId}

                    className="border-b border-gray-300 cursor-pointer text-center"
                  >
                    <td className="px-4 py-4 text-sm text-gray-700">{consultation.consultationId || "TBD"}</td>
                    <td className="px-4 py-4 text-sm text-gray-700">{consultation.studentName || "TBD"}</td>
                    <td className="px-4 py-4 text-sm text-gray-700">{consultation.email || "TBD"}</td>
                    <td className="px-4 py-4 text-sm text-gray-700">{consultation.consultationDate || "TBD"}</td>
                    <td className="px-4 py-4 text-sm text-gray-700">{consultation.consultationTime || "TBD"}</td>
                    <td className="px-4 py-4 text-sm text-gray-700">
                      {consultation.meetingLink ?

                        (<a
                          className="text-blue-500"
                          title="Join meeting"
                          href={consultation.meetingLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => e.stopPropagation()}
                        >
                          join
                        </a>) : (<span className="text-gray-500">TBD</span>)
                      }
                    </td>
                    <td className="flex justify-center px-4 py-4 text-sm ">
                      <FaEdit
                        onClick={() => openModal(consultation)}
                        className="text-blue-500 size-5 cursor-pointer hover:text-blue-600" />
                    </td>
                  </tr>
                )) :
                  <tr>
                    <td colSpan="7" className="px-4 py-4 text-sm text-gray-700 text-center">
                      No data available
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <ModalInProcess
          isOpen={isModalOpen}
          onClose={closeModal}
          consultation={selectedConsultation}
          consultant={consultants}
          fetchConsultations={fetchConsultations}
        />
      )}
    </>
  )
}

export default NewRequests